import React, { useState } from 'react';
import './Style/Contact.css';
import TopNavbar from './/../home/TopNavbar';
import { API_CONFIG } from './../config'; 
import { Link } from 'react-router-dom';

const CREATE_USER_CONTACT = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.STUDENTMESSAGE}`;

const StudentContact = () => {
    // Primary and Backup Email Addresses
    const paymentsEmail = 'payments@mystudyplace.online';
    const contactEmail = 'contact@mystudyplace.online';
    const backupEmail = 'sarwar93390@gmail.com';

    const phoneFromStorage = localStorage.getItem('userPhone');
    const emailFromStorage = localStorage.getItem('userEmail');
    const nameFromStorage = localStorage.getItem('userName');

    const messageTypes = [
        { value: '', label: 'Select Issue Type' },
        { value: 'payment', label: '💰 Payment Issue' },
        { value: 'technical', label: '🔧 Technical Issue' },
        { value: 'app_problem', label: '📱 App Problem' },
        { value: 'content', label: '📚 Content Issue' },
        { value: 'feature', label: '💡 Feature Request' },
        { value: 'other', label: '📝 Other' }
    ];

    const [formData, setFormData] = useState({
        name: nameFromStorage || '',
        phone: phoneFromStorage || '',
        email: emailFromStorage || '',
        type: '',
        subject: '',
        message: ''
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submissionStatus, setSubmissionStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        setSubmissionStatus(null);
        setErrorMessage('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmissionStatus(null);
        setErrorMessage('');

        if (!formData.name || !formData.phone || !formData.email || !formData.type || !formData.subject || !formData.message) {
            setSubmissionStatus('validation_error');
            setErrorMessage('Please fill in all required fields before submitting.');
            setIsSubmitting(false);
            return;
        }

        if (formData.subject.length > 100) {
            setSubmissionStatus('validation_error');
            setErrorMessage('Subject must not exceed 100 characters.');
            setIsSubmitting(false);
            return;
        }

        if (formData.message.length > 1000) {
            setSubmissionStatus('validation_error');
            setErrorMessage('Message must not exceed 1000 characters.');
            setIsSubmitting(false);
            return;
        }

        try {
            const response = await fetch(CREATE_USER_CONTACT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const responseData = await response.json();

            if (!response.ok) {
                throw new Error(responseData.message || 'Submission failed');
            }

            setSubmissionStatus('success');

            setFormData(prev => ({
                ...prev,
                type: '',
                subject: '',
                message: ''
            }));
        } catch (error) {
            console.error('Contact submission error:', error.message);
            setSubmissionStatus('error');
            setErrorMessage(error.message || 'Failed to send your message. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="student-contact-page">
            <TopNavbar name="Contact Support" />

            <div className="contact-form-section" style={{ marginTop: '20px' }}>
                <div className="contact-header">
                    <h2>📧 Contact Us</h2>
                    <p>Have a question or need help? Fill out the form below and our team will get back to you.</p>
                </div>

                <form onSubmit={handleSubmit} className="contact-form">
                    <div className="form-section">
                        <h3>Message Details</h3>

                        <div className="form-group">
                            <label htmlFor="type">Type of Issue *</label>
                            <select
                                id="type"
                                name="type"
                                value={formData.type}
                                onChange={handleInputChange}
                                required
                                className="type-select"
                            >
                                {messageTypes.map((type) => (
                                    <option key={type.value} value={type.value}>
                                        {type.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="form-group">
                            <label htmlFor="subject">Subject *</label>
                            <input
                                type="text"
                                id="subject"
                                name="subject"
                                value={formData.subject}
                                onChange={handleInputChange}
                                placeholder="Brief subject of your message"
                                maxLength={100}
                                required
                            />
                            <small className="char-count">
                                {formData.subject.length} / 100 characters
                            </small>
                        </div>

                        <div className="form-group">
                            <label htmlFor="message">Message *</label>
                            <textarea
                                id="message"
                                name="message"
                                rows="6"
                                value={formData.message}
                                onChange={handleInputChange}
                                placeholder="Please describe your issue in detail..."
                                maxLength={1000}
                                required
                            ></textarea>
                            <small className="char-count">
                                {formData.message.length} / 100 characters
                            </small>
                        </div>
                    </div>

                    {submissionStatus === 'validation_error' && (
                        <div className="status-message error">
                            ❌ {errorMessage}
                        </div>
                    )}

                    {submissionStatus === 'success' && (
                        <div className="status-message success">
                            ✅ Thank you for contacting us! Your message has been sent successfully.
                        </div>
                    )}

                    {submissionStatus === 'error' && (
                        <div className="status-message error">
                            ❌ {errorMessage}
                        </div>
                    )}

                    {phoneFromStorage ? (
                        <button
                            type="submit"
                            className="submit-btn"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? (
                                <>
                                    <span className="spinner"></span> Sending...
                                </>
                            ) : (
                                'Send Message'
                            )}
                        </button>
                    ) : (
                        <Link to="/signup" className="submit-btn" style={{ textDecoration: "none", display: "inline-block", textAlign: "center" }}>
                            Create Account Before Sending Message
                        </Link>
                    )}
                </form>

                {/* Additional Direct Contact Methods */}
                <div className="contact-methods" style={{ marginTop: '30px' }}>
                    {/* Payment & Billing Assistance */}
                    <div className="contact-item">
                        <div className="icon">💳</div>
                        <h3>Payment &amp; Billing Support</h3>
                        <p>
                            Having issues with unlocked mock tests or payment deductions? Email us with your <strong>Google Play Order ID</strong> <br></br> (e.g., <code>GPA.1234-5678-9012-34567</code>):
                        </p>
                        <a href={`mailto:${paymentsEmail}?subject=NEET%20Prep%20Payment%20Issue`} className="email-button">
                            {paymentsEmail}
                        </a>
                        <br />
                        <a href={`mailto:${backupEmail}?subject=NEET%20Prep%20Payment%20Issue`} className="email-button" style={{ marginTop: '8px' }}>
                            {backupEmail}
                        </a>
                    </div>

                    <hr className="contact-divider" />

                    {/* Student Support Section */}
                    <div className="contact-item">
                        <div className="icon">🛠️</div>
                        <h3>Student Support</h3>
                        <p>Need help with DPPs, Mock Tests, or your Practice History?</p>
                        <a href={`mailto:${contactEmail}`} className="email-button">
                            {contactEmail}
                        </a>
                    </div>

                    <hr className="contact-divider" />

                   
                </div>
                <br></br><br></br>
            </div>
            <br /><br /><br />
        </div>
    );
};

export default StudentContact;